export const fonts = {
  body: `Myriad, sans-serif`,
  heading: `Effra, sans-serif`
};
